import { Grid, Typography, ButtonBase, Accordion, AccordionSummary, AccordionDetails, Box } from "@mui/material";
import { useParams, Link } from "react-router-dom";
import soluciones from "../../Data/soluciones.json";
import { useEffect } from "react";
import { useResponsive } from "../../Modulo_Responsive/Hooks/useResponsive";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const Seccion_Enfoque_Dinamico = () => {
    const { categoria } = useParams();
    const { sCell } = useResponsive();
    const navigate = useNavigate();

    const slug = `/servicios/${categoria}/`;
    const item = soluciones.find(s => s.slug === slug);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [slug]);



    return (
        <>
            <Helmet>
                <title>{item.title} en Cali | Espacio Compacto</title>
                <meta name="description" content={item.metaDescripcion} />
                <meta name="keywords" content={item.keywords?.join(", ")} />
                <link rel="canonical" href={`https://espaciocompacto.com${item.slug}`} />
                <meta property="og:title" content={`${item.titulo} en Cali`} />
                <meta property="og:description" content={item.metaDescripcion} />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={`https://espaciocompacto.com${item.slug}`} />
                <meta property="og:locale" content="es_CO" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={`${item.titulo} en Cali`} />
                <meta name="twitter:description" content={item.metaDescripcion} />
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Service",
                        "name": item.titulo,
                        "description": item.metaDescripcion,
                        "areaServed": { "@type": "City", "name": "Cali" },
                        "provider": {
                            "@type": "Organization",
                            "name": "Espacio Compacto",
                            "url": "https://espaciocompacto.com"
                        },
                        "url": `https://espaciocompacto.com${item.slug}`
                    })}
                </script>
            </Helmet>

            <Grid
                container
                justifyContent="center"
                alignItems="center"
                size={{xs: 12, sm: 12, md: 12}}
                sx={{  pt:sCell?12:20, pb: sCell?0:8,   }}
            >
                <Grid
                    container
                    justifyContent="center"
                    alignItems="center"
                    size={{ xs: 12, sm: 12, md: 10 }}
                    sx={{px:3, }}
                >

                    {/* ── HERO ── */}
                    <Grid
                        container
                        justifyContent="center"
                        alignItems="flex-start"
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{ borderBottom: '1px solid #223B59', pb:12, maxWidth:1400}}
                        spacing={sCell ? 4 : 8}
                    >
                        <Grid
                            container
                            justifyContent="center"
                            alignItems="flex-start"
                            size={{ xs: 12, sm: 12, md: 7 }}>
                            <Typography component="h1" variant="h1">
                                {item.titulo}
                            </Typography>
                        </Grid>

                        <Grid
                            container
                            justifyContent="center"
                            alignItems="flex-start"
                            size={{ xs: 12, sm: 12, md: 5 }} >
                            <Typography
                                component="p"
                                variant="body1"
                            >
                                {item.descripcion}
                            </Typography>
                        </Grid>
                    </Grid>

                    {/* ── SUBSERVICIOS / CARDS ── */}
                    <Grid container size={{ xs: 12 }} spacing={4} sx={{ pt:sCell?8:16, maxWidth:1400}}>
                        {item.servicios && Array.isArray(item.servicios) && item.servicios.map((servicio, idx) => (
                            <Grid
                                key={idx}
                                container
                                direction="column"
                                size={{ xs: 12, sm: 6, md: 4 }}
                            >
                                <Typography
                                    component="h2"
                                    variant="h3"
                                    sx={{  mb: 0 }}
                                >
                                    {servicio.titulo}
                                </Typography>

                                <Typography
                                    component="p"
                                    variant="body1"
                                    sx={{ mb: 2, minHeight: '80px' }}
                                >
                                    {servicio.descripcion}
                                </Typography>

                                <ButtonBase
                                    onClick={() => navigate(servicio.slug.replace(/\/$/, ''))}
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'flex-start',
                                        gap: 0.5,
                                        color: '#223B59',
                                        background: 'transparent',
                                        transition: '0.3s',
                                        '&:hover': { opacity: 0.6 },
                                    }}
                                >
                                    <Typography component="span" variant="body1" sx={{ fontSize: 15, fontWeight: 500, color: '#223B59' }}>
                                        Más información
                                    </Typography>
                                    <ArrowForwardIosIcon sx={{ fontSize: 13, color: '#223B59' }} />
                                </ButtonBase>
                            </Grid>
                        ))}
                    </Grid>

                    {/* ── INTRO SEO ── */}
                    {item.intro_seo && (
                        <Grid container justifyContent={"center"} size={{ xs: 12 }} sx={{ pt:sCell?8:16, maxWidth:1400}}>
                            <Grid size={{ xs: 12, md: 12 }}>
                                <Typography
                                    textAlign={"center"}
                                    component="p"
                                    variant="body1"
                                    sx={{ }}
                                >
                                    {item.intro_seo}
                                </Typography>
                            </Grid>
                        </Grid>
                    )}

                    {/* ── PROCESO ── */}
                    {item.proceso && Array.isArray(item.proceso) && item.proceso.length > 0 && (
                        <Grid container size={{ xs: 12 }} sx={{ pt:sCell?8:16, maxWidth:1400}}>
                            <Grid size={{ xs: 12 }} sx={{ mb: 8 }}>
                                <Typography
                                    component="h2"
                                    variant="h2"
                                    sx={{}}
                                >
                                    ¿Cómo trabajamos?
                                </Typography>
                            </Grid>

                            <Grid container size={{ xs: 12 }} sx={{mb:sCell?8:16,}} spacing={2}>
                                {item.proceso.map((paso, idx) => (
                                    <Grid
                                        key={idx}
                                        size={{ xs: 12, sm: 6, md: 3 }}
                                        sx={{
                                            border: '1px solid #223B59',
                                            borderRadius: 2,
                                            p: 3,
                                            mb:sCell?2:0,
                                        }}
                                    >
                                        <Typography
                                            sx={{ fontSize: 11, fontWeight: 500, color: '#223B59', opacity: 0.5, mb: 1, letterSpacing: '0.08em' }}
                                        >
                                            {paso.numero}
                                        </Typography>
                                        <Typography
                                            component="h3"
                                            variant="h3"
                                            sx={{ mb: 1,}}
                                        >
                                            {paso.titulo}
                                        </Typography>
                                        <Typography
                                            component={"p"}
                                            variant="body3"
                                            sx={{ opacity:0.8}}
                                        >
                                            {paso.descripcion}
                                        </Typography>
                                    </Grid>
                                ))}
                            </Grid>
                        </Grid>
                    )}

                    {/* ── CONTEXTO TÉCNICO ── */}
                    {item.contexto_tecnico && (
                        <Grid
                            container
                            size={{ xs: 12 }}
                            sx={{ mb: sCell?8:16, borderTop: '1px solid #223B59', pt: sCell?8:16, maxWidth:1400 }}
                            spacing={sCell ? 8 : 8}
                        >
                            <Grid size={{ xs: 12, md:  12}}>
                                <Typography
                                    component="h2"
                                    variant="h2"
                                    sx={{ }}
                                >
                                    {item.contexto_tecnico.titulo}
                                </Typography>
                            </Grid>

                            <Grid size={{ xs: 12, md: 12 }}>
                                {item.contexto_tecnico.parrafos && Array.isArray(item.contexto_tecnico.parrafos) && item.contexto_tecnico.parrafos.map((p, i) => (
                                    <Typography
                                        key={i}
                                        component="p"
                                        variant="body1"
                                        sx={{

                                            mb: i < item.contexto_tecnico.parrafos.length - 1 ? 2.5 : 0,
                                        }}
                                    >
                                        {p}
                                    </Typography>
                                ))}
                            </Grid>
                        </Grid>
                    )}

                    {/* ── BENEFICIOS CLAVE ── */}
                    {item.beneficios_clave && Array.isArray(item.beneficios_clave) && item.beneficios_clave.length > 0 && (
                        <Grid container size={{ xs: 12 }} sx={{ mb: sCell?8:16, borderTop: '1px solid #223B59', pt: sCell?8:16, maxWidth:1400 }}>
                            <Grid size={{ xs: 12 }} sx={{ mb: 8 }}>
                                <Typography
                                    component="h2"
                                    variant={"h2"}
                                    sx={{ }}
                                >
                                    ¿Por qué elegirnos?
                                </Typography>
                            </Grid>

                            <Grid container size={{ xs: 12 }} spacing={sCell ? 6 : 0}>
                                {item.beneficios_clave.map((ben, idx) => {
                                    const imagenIzquierda = idx % 2 === 0;
                                    return (
                                        <Grid
                                            key={idx}
                                            container
                                            size={{ xs: 12 }}
                                            alignItems="center"
                                            direction={sCell ? 'column' : (imagenIzquierda ? 'row' : 'row-reverse')}
                                            spacing={sCell ? 3 : 8}
                                            sx={{
                                                mb: sCell ? 0 : 8,
                                                pb: sCell ? 0 : (idx < item.beneficios_clave.length - 1 ? 8 : 0),
                                                borderBottom: (!sCell && idx < item.beneficios_clave.length - 1)
                                                    ? '1px solid rgba(34,59,89,0.12)'
                                                    : 'none',
                                            }}
                                        >
                                            {/* Imagen */}
                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Box
                                                    component="img"
                                                    src={ben.imagen}
                                                    alt={ben.alt || ben.titulo}
                                                    sx={{
                                                        width: '100%',
                                                        height: sCell ? 220 : 320,
                                                        objectFit: 'cover',
                                                        display: 'block',
                                                    }}
                                                />
                                            </Grid>

                                            {/* Texto */}
                                            <Grid
                                                size={{ xs: 12, md: 6 }}
                                                sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}
                                            >
                                                <Typography
                                                    component="h3"
                                                    variant={"h3"}
                                                    sx={{}}
                                                >
                                                    {ben.titulo}
                                                </Typography>
                                                <Typography
                                                    component="p"
                                                    variant="body1"
                                                    sx={{  }}
                                                >
                                                    {ben.descripcion}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    );
                                })}
                            </Grid>
                        </Grid>
                    )}

                    {/* ── ERRORES COMUNES ── */}
                    {item.errores_comunes && item.errores_comunes.items && Array.isArray(item.errores_comunes.items) && item.errores_comunes.items.length > 0 && (
                        <Grid container size={{ xs: 12 }} sx={{ mb: sCell?8:16, borderTop: '1px solid #223B59', pt: sCell?8:16, maxWidth:1400 }}>
                            <Grid size={{ xs: 12 }} sx={{ mb: 8 }}>
                                <Typography
                                    component="h2"
                                    variant="h2"
                                    sx={{ }}
                                >
                                    {item.errores_comunes.titulo}
                                </Typography>
                            </Grid>

                            <Grid container size={{ xs: 12 }} spacing={sCell?4:8}>
                                {item.errores_comunes.items.map((error, idx) => (
                                    <Grid key={idx} size={{ xs: 12, sm: 6 }}>
                                        <Box
                                            sx={{
                                                height: '100%',
                                            }}
                                        >
                                            <Typography
                                                component="h3"
                                                variant="h3"
                                                sx={{ pb:4 }}
                                            >
                                                {error.titulo}
                                            </Typography>
                                            <Typography
                                                component={"p"}
                                                variant={"body1"}
                                                sx={{  }}
                                            >
                                                {error.descripcion}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                ))}
                            </Grid>
                        </Grid>
                    )}

                    {/* ── PREGUNTAS FRECUENTES ── */}
                    {item.preguntas_frecuentes && Array.isArray(item.preguntas_frecuentes) && item.preguntas_frecuentes.length > 0 && (
                        <Grid container size={{ xs: 12 }} sx={{ mb: sCell?8:16, borderTop: '1px solid #223B59', pt: sCell?8:16, maxWidth:1400 }}>
                            <Grid size={{ xs: 12 }} sx={{ mb: 8 }}>
                                <Typography
                                    component="h2"
                                    variant={"h2"}
                                    sx={{  }}
                                >
                                    Preguntas frecuentes
                                </Typography>
                            </Grid>

                            <Grid size={{ xs: 12 }}>
                                {item.preguntas_frecuentes.map((faq, idx) => (
                                    <Accordion
                                        key={idx}
                                        disableGutters
                                        elevation={0}
                                        sx={{
                                            borderBottom: '1px solid #223B59',
                                            background: 'transparent',
                                            '&:before': { display: 'none' },
                                        }}
                                    >
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon sx={{ color: '#223B59' }} />}
                                            sx={{ px: 0, py: 1 }}
                                        >
                                            <Typography
                                                component="h3"
                                                variant="h3"
                                                sx={{  }}
                                            >
                                                {faq.pregunta}
                                            </Typography>
                                        </AccordionSummary>
                                        <AccordionDetails sx={{ px: 0, pb: 2 }}>
                                            <Typography
                                                component="p"
                                                variant="body1"
                                                sx={{ }}
                                            >
                                                {faq.respuesta}
                                            </Typography>
                                        </AccordionDetails>
                                    </Accordion>
                                ))}
                            </Grid>
                        </Grid>
                    )}

                    {/* ── CTA ── */}
                    {item.cta && (
                        <Grid
                            container
                            size={{ xs: 12 }}
                            justifyContent="space-between"
                            alignItems="center"
                            sx={{
                                background: '#223B59',

                                p: sCell ? 3 : 5,
                                gap: 3,
                                flexDirection: sCell ? 'column' : 'row',
                            }}
                        >
                            <Grid size={{ xs: 12, md: 8 }}>
                                <Typography
                                    component="h2"
                                    variant="h2"
                                    sx={{color: '#fff', mb: 4 }}
                                >
                                    {item.cta.titulo}
                                </Typography>
                                <Typography
                                    component="p"
                                    variant="body1"
                                    sx={{ color: 'rgba(255,255,255,0.65)',  }}
                                >
                                    {item.cta.descripcion}
                                </Typography>
                            </Grid>

                            <Grid>
                                <ButtonBase
                                    onClick={() => navigate(item.cta.enlace)}
                                    sx={{
                                        background: '#fff',
                                        color: '#223B59',
                                        px: 3,
                                        py: 1.5,
                                        fontSize: 14,
                                        fontWeight: 600,
                                        transition: '0.2s',
                                        '&:hover': { opacity: 0.85 },
                                    }}
                                >
                                    {item.cta.boton}
                                </ButtonBase>
                            </Grid>
                        </Grid>
                    )}

                </Grid>
            </Grid>
        </>
    );
};

export default Seccion_Enfoque_Dinamico;
